<div class="card infoEmpresa datos_element_to_target {{ getClass() }}">
    <div class="card-header">
        <div class="row">
            <div class="col-6 col-md-8 text-left" translate>
                <h1 class="d-none d-md-inline-block" translate>manager.compayInfoTitl</h1>
                <span class="d-inline-block d-md-none" translate>manager.compayInfoTitlMin</span>
                <span class="notaCabecera d-none d-sm-inline-block" translate>manager.compayInfoTitlAux</span>
            </div>
            <div class="col-6 col-md-4 text-right botonera">
                <button title="{{'manager.editCompany.dataRecharge' | translate}}" (click)="rechargeCompanyInfo()">
                    <i class="fa fa-refresh"></i></button>
                <button *ngIf="!creationMode" [disabled]="isEditingAuthorizeds()" title="{{'manager.editCompany.authorizedCmp' | translate}}" (click)="editInvoicingAuthorizeds()"><i class="fa fa-users"></i></button>
                <button *ngIf="!creationMode" [disabled]="isEditingCompanyInfo()" title="{{'manager.editCompany.editCmp' | translate}}" (click)="editInvoicingService()"><i class="fa fa-pencil"></i></button>
            </div>
        </div>
    </div>

    <div class="card-body">
        <div class="datosEmpresa">
            <span class="nombre">{{ person.tradeName }}</span>
            <span class="codigo">{{ person.identifier }}</span>
            <span class="direccion">{{ person.address }}</span>
            <span class="telefonos">{{ person.phone }}</span>
            <span *ngIf="!isEditingCompanyInfo()" class="email">{{ person.email }}</span>

            <div class="bloqueEditable">
                <div *ngIf="isEditingCompanyInfo()" class="email">
                    <label>Email</label>
                    <input title="email" type="text" [(ngModel)]="person.email" class="col-12 col-md-5" (keyup.enter)="openConfirmEditInv()">
                </div>
                <div *ngIf="errors && errors['email'] && errors['email'].length > 0" class="notaPie col-7">
                    <span *ngFor="let error of errors['email']">{{ error }}</span>
                </div>

                <span class="descripcion">{{ person.description }}</span>

                <!-- If invoicing service exists -->
                <div *ngIf="person['servicesToOthers'] != undefined && !isEditingCompanyInfo()" [ngClass]="{'noPrestaTerceros': !hasServicesToOthers()}" class="serviceToOthers">
                    <i class="fa fa-briefcase"></i><span translate>manager.editCompany.serviceToOthers</span>
                </div>
                <div class="campoCheck serviceToOthers" *ngIf="isEditingCompanyInfo()">
                    <label class="form-check-label pseudocheck">
                        <input class="form-check-input" type="checkbox" id="checkboxDireListAdded" [(ngModel)]="person.servicesToOthers" name="servicesToOthers">
                        <span translate>manager.editCompany.serviceToOthers</span>
                    </label>
                </div>

                <div *ngIf="isEditingCompanyInfo()" class="col-12 botonera">
                    <div>
                        <button title="Cancel" class="" (click)="cancelInvoicingService()"><i  class="fa fa-times"> <span  class="d-none d-lg-inline-block" translate="">manager.editCompany.cancelCmp</span></i></button>
                        <button title="" class="" (click)="openConfirmEditInv()" translate><i  class="fa fa-check"> <span  class="d-none d-lg-inline-block" translate="">manager.editCompany.saveCmp</span></i></button>
                    </div>
                </div>
            </div>

            <!-- Autorizados -->
            <app-inv-authorized-list [person]="person" *ngIf="isEditingAuthorizeds()"></app-inv-authorized-list>
            <div *ngIf="isEditingAuthorizeds()" class="col-12 botonera">
                <div>
                    <button title="Cancel" class="" (click)="cancelInvoicingService()"><i  class="fa fa-times"> <span  class="d-none d-lg-inline-block" translate="">manager.editCompany.closeCmp</span></i></button>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- MODAL confirm edit invoicingService -->
<ng-template #confirmServiceToOthers let-c="close">
    <div class="modal-header">
        <h5 class="modal-title" translate>manager.editCompany.modal.title</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="c('cancel')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <p translate>manager.editCompany.modal.body</p>
    </div>
    <div class="modal-footer">
        <div class="botonera">
            <button type="button" (click)="c('cancel')" class="btn btn-secondary" translate>manager.editCompany.cancelCmp</button>
            <button type="button" class="btn btn-primary" (click)="c('editInv')" translate>manager.editCompany.acceptCmp</button>
        </div>
    </div>
</ng-template>



// WEBPACK FOOTER //
// ./src/app/app-manager/invoicing-services/inv-company-info/inv-company-info.component.html